module.exports = __webpack_public_path__ + "static/media/review-salary-worker-first.40f6f086.png";